const ebitdaScheduleTemplate = (() => {
    const main = {
        "1": {
            "config": {
                "class": "container"
            },
            "tag": "div",
            "parent": -1
        },
        "2": {
            "config": {
                "class": "monthly-summery"
            },
            "tag": "div",
            "parent": 1
        },
        "3": {
            "config": {
                "class": "row pt-3"
            },
            "tag": "div",
            "parent": 2
        },
        "4": {
            "config": {
                "class": "col-3"
            },
            "tag": "div",
            "parent": 3
        },
        "5": {
            "config": {
                "class": "pb-0"
            },
            "tag": "h4",
            "parent": 4,
            "html": "{value}"
        },
        "6": {
            "config": {
                "class": "col"
            },
            "tag": "div",
            "parent": 3,
            "html": ""
        },
        "7": {
            "config": {
                "class": "col-3"
            },
            "tag": "div",
            "parent": 3
        },
        "8": {
            "config": {
                "class": "nav nav-tabs graphicalView float-right"
            },
            "tag": "ul",
            "parent": 7
        },
        "9": {
            "config": {
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 8
        },
        "10": {
            "config": {
                "class": "nav-link",
                "id": "hideShowGraphicalView",
                "data-toggle": "tab",
                "href": "#graphicalView"
            },
            "tag": "a",
            "parent": 9,
            "html": "Graphical View",
            "events": [
                {
                    "id": "hideShowGraphicalView",
                    "name": "click",
                    "callback": "hideShowSectionsOverride"
                }
            ]
        },
        "11": {
            "config": {
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 8
        },
        "12": {
            "config": {
                "class": "nav-link tableview",
                "id": "hideShowTableView",
                "data-toggle": "tab",
                "href": "#tableView"
            },
            "tag": "a",
            "parent": 11,
            "html": "Table View",
            "events": [
                {
                    "id": "hideShowTableView",
                    "name": "click",
                    "callback": "hideShowSections"
                }
            ]
        },
        "13": {
            "config": {
                "class": "row mt-4"
            },
            "tag": "div",
            "parent": 1
        },
        "14": {
            "config": {
                "class": "col-12"
            },
            "tag": "div",
            "parent": 13
        },
        "15": {
            "config": {
                "class": "card p-0 pt-3"
            },
            "tag": "div",
            "parent": 14
        },
        "16": {
            "config": {
                "class": "card-body p-0"
            },
            "tag": "div",
            "parent": 15
        },
        "17": {
            "config": {
                "class": "nav nav-tabs tab-lg"
            },
            "tag": "ul",
            "parent": 16
        },
        "18": {
            "config": {
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 17
        },
        "19": {
            "config": {
                "class": "nav-link active",
                "data-toggle": "tab",
                "href": "#estOperatingProfitScheduleView"
            },
            "tag": "a",
            "parent": 18,
            "html": "Est. Operating Profit Schedule & Existing Debt Service"
        },
        "20": {
            "config": {
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 17
        },
        "21": {
            "config": {
                "class": "nav-link",
                "style": {
                    "display": "none"
                },
                "data-toggle": "tab",
                "href": "#dscrCalculationsTab"
            },
            "tag": "a",
            "parent": 20,
            "html": "DSCR Calculations"
        },
        "22": {
            "config": {
                "style": { "display": "none"},
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 17
        },
        "23": {
            "config": {
                "class": "nav-link",
                "data-toggle": "tab",
                "href": "#existingDebtServiceViewTab"
            },
            "tag": "a",
            "parent": 22,
            "html": "Existing Debt Service"
        },
        "24": {
            "config": {
                "class": "payment-graph mt-4 hideShowSection1",
            },
            "tag": "div",
            "parent": 1
        },
        "25": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 24
        },
        "26": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 25
        },
        "27": {
            "config": {
                "class": "card p-0"
            },
            "tag": "div",
            "parent": 26
        },
        "28": {
            "config": {
                "class": "card-header pb-4"
            },
            "tag": "div",
            "parent": 27
        },
        "29": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 28
        },
        "30": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            // "parent": 29
            "parent": 48
        },
        "31": {
            "config": {
            },
            "tag": "strong", //"h4",
            "parent": 30,
            "html": "Adjustable safety margin for Current Debt",
        },
        "32": {
            "config": {
                "class": "row mt-3"
            },
            "tag": "div",
            "parent": 28
        },
        "33": {
            "config": {
                "class": "col-6 progress-constraint-1"
            },
            "tag": "div",
            // "parent": 32
            "parent": 217
        },
        "34": {
            "config": {
                "type": "text",
                "data-slider-min": "0.01",
                "data-slider-max": "2",
                "data-slider-step": "0.01",
                "data-slider-value": "1.25",
                "class": "slider progress-bar-1 bg-green widget-range-slider",
                "id": "ebitdaSlider1"
            },
            "tag": "input",
            "parent": 33,
            "events": [
                {
                    "id": "ebitdaSlider1",
                    "name": "change",
                    "callback": "currentSafetyMarginRatio"
                }
            ]
        },
        // "35": {
        //     "config": {
        //         "class": "marginValue",
        //     },
        //     "tag": "span",
        //     "html": "{profit_margin_ratio}",
        //     "parent": 34
        // },
        "38": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 27
        },
        "39": {
            "config": {
                "class": "font-b pb-3"
            },
            "tag": "h5",
            "parent": 38,
            "html": "Est. Operating Profit Computation"
        },
        "40": {
            "config": {
                "class": "graph ebitdaLeftGraph"
            },
            "tag": "div",
            "parent": 38
        },
        "42": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 25
        },
        "43": {
            "config": {
                "class": "card p-0"
            },
            "tag": "div",
            "parent": 42
        },
        "44": {
            "config": {
                "class": "card-header pb-4"
            },
            "tag": "div",
            "parent": 43
        },
        "45": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 44
        },
        "46": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 48//45
        },
        "47": {
            "config": {},
            "tag": "strong", //"h4",
            "parent": 46,
            "html": "Adjustable safety margin for Future Debt",
        },
        "201": {
            "config": {
                "class": "col-3 ml-auto text-right"
            },
            "tag": "div",
            "parent": 45
        },
        "202": {
            "config": {
                "class": "input-group  "
            },
            "tag": "div",
            "parent": 201
        },
        "203": {
            "config": {
                "for": "debtService",
                "class": "sr-only"
            },
            "tag": "label",
            "parent": 202,
            "html": "DSCR Calculations"
        },
        "204": {
            "config": {
                "class": "custom-select ml-3 groupTransactionsFilter",
                "id": "quarterFilterOption"
            },
            "tag": "select",
            "parent": 202,
            "events": [
                {
                    "id": "quarterFilterOption",
                    "name": "click",
                    "callback": "getSelectedValue"
                }
            ]
        },
        "48": {
            "config": {
                "class": "row mt-3"
            },
            "tag": "div",
            "parent": 44
        },
        "49": {
            "config": {
                // "class": "col-12"
                "class": "col-6"
            },
            "tag": "div",
            "parent": 217//48
        },
        "50": {
            "config": {
                "class": "progress-constraint-2"
            },
            "tag": "div",
            "parent": 49
        },
        "51": {
            "config": {
                "type": "text",
                "data-slider-min": "0.01",
                "data-slider-max": "2",
                "data-slider-step": "0.01",
                "data-slider-value": "1.25",
                "class": "slider progress-bar-2 bg-green widget-range-slider",
                "id": "ebitdaSlider2"
            },
            "tag": "input",
            "parent": 50,
            "events": [
                {
                    "id": "ebitdaSlider2",
                    "name": "input",
                    "callback": "additionalSafetyMarginRatio"
                }
            ]
        },
        "54": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 43
        },
        "55": {
            "config": {
                "class": "font-b pb-3"
            },
            "tag": "h5",
            "parent": 54,
            "html": "Future Debt Capacity"
        },
        "56": {
            "config": {
                "class": "graph ebitdaRightGraph"
            },
            "tag": "div",
            "parent": 54
        },
        "58": {
            "config": {
                "id": "tableview",
                "class": "listStatement card p-0 graycard hideShowSection2"
            },
            "tag": "div",
            "parent": 1
        },
        "59": {
            "config": {
                "class": "card-header pt-4"
            },
            "tag": "div",
            "parent": 58
        },
        "60": {
            "config": {
                "class": "row form-inline"
            },
            "tag": "div",
            "parent": 59
        },
        "61": {
            "config": {
                "class": "col-7"
            },
            "tag": "div",
            "parent": 60
        },
        "62": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 61
        },
        "71": {
            "config": {
                "class": "col-5"
            },
            "tag": "div",
            "parent": 60
        },
        "72": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 71
        },
        "73": {
            "config": {
                "class": "col-9"
            },
            "tag": "div",
            "parent": 72
        },
        "74": {
            "config": {
                "class": "input-group"
            },
            "tag": "div",
            "parent": 73
        },
        "75": {
            "config": {
                "for": "updatedDSCR",
                "class": "w-50"
            },
            "tag": "label",
            "parent": 74,
            "html": "Updated DSCR after applying proposed debt amount"
        },
        "76": {
            "config": {
                "id": "updatedDSCR",
                "type": "number",
                "disabled": "",
                "class": "custom-input w-50",
            },
            "tag": "input",
            "parent": 74,
            "html": ""
        },
        "77": {
            "config": {
                "class": "col-3"
            },
            "tag": "div",
            "parent": 72
        },
        "78": {
            "config": {
                "type": "button",
                "id": "resetDSCR",
                "class": "btn btn-primary btn-md w-100s"
            },
            "tag": "button",
            "parent": 77,
            "html": "Reset",
            "events": [
                {
                    "id": "resetDSCR",
                    "name": "click",
                    "callback": "setDefaultDSCR"
                }
            ]
        },
        "79": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 58
        },
        "80": {
            "config": {
                "class": "ebitdaNumberOfMonths"
            },
            "tag": "h6",
            "parent": 79,
            "html": ""
        },
        "81": {
            "config": {
                "class": "data-wrap-fixed row m-0 grayTable shadowNone"
            },
            "tag": "div",
            "parent": 79
        },
        "82": {
            "config": {
                "class": "col-2 dataLeft-fixed p-0 dscrScheduleDataLeftFixed"
            },
            "tag": "div",
            "parent": 81
        },
        "88": {
            "config": {
                "class": "col-10 p-0"
            },
            "tag": "div",
            "parent": 81
        },
        "89": {
            "config": {
                "class": "mid-panel dscrScheduleMidPanel"
            },
            "tag": "div",
            "parent": 88
        },
        "90": {
            "config": {
                "class": "row data-head m-0 dscrScheduleDataHead"
            },
            "tag": "div",
            "parent": 89
        },
        "150": {
            "config": {
                "class": "row",
            },
            "tag": "div",
            "parent": 1,
        },
        "151": {
            "config": {
                "class": "col-6",
            },
            "tag": "div",
            "parent": 150,
        },
        "152": {
            "config": {
                "class": "col-6",
                // "style": {"display":"none"}
            },
            "tag": "div",
            "parent": 150,
        },
        "115": {
            "config": {
                "class": "card p-0 mt-4",
                "id": "estOperatingProfitScheduleView",
            },
            "tag": "div",
            "parent": 151
        },
        "116": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 115
        },
        "117": {
            "config": {},
            "tag": "h4",
            "parent": 116,
            "html": "Est. Operating Profit Schedule"
        },
        "118": {
            "config": {
                "class": "data-wrap data-border no-striped"
            },
            "tag": "div",
            "parent": 116
        },
        "119": {
            "config": {
                "class": "row data-head borderbottom m-0 EstOperatingProfitScheduleHeader"
            },
            "tag": "div",
            "parent": 118
        },
        "127": {
            "config": {
                "class": "card p-0 mt-4",
                "id": "DebtInEstOpr"
            },
            "tag": "div",
            "parent": 152
        },
        "128": {
            "config": {
                "class": "data-body EstOperatingProfitScheduleRow"
            },
            "tag": "div",
            "parent": 118
        },

        "129": {
            "config": {
                "class": "card p-0 mt-4",
                "id": "dscrCalculationsView",
            },
            "tag": "div",
            "parent": 152
        },
        "130": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 129
        },
        "131": {
            "config": {},
            "tag": "h4",
            "parent": 130,
            "html": "DSCR Calculations"
        },
        "132": {
            "config": {
                "class": "data-wrap data-border no-striped"
            },
            "tag": "div",
            "parent": 130
        },
        "133": {
            "config": {
                "class": "row data-head borderbottom m-0 dscrCalculationsHeader"
            },
            "tag": "div",
            "parent": 132
        },
        "134": {
            "config": {
                "class": "data-body dscrCalculationsRow"
            },
            "tag": "div",
            "parent": 132
        },

        "164": {
            "config": {
                "class": "card p-0 mt-4",
                "id": "existingDebtServiceViewTab",
            },
            "tag": "div",
            "parent": 1
        },
        "165": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 164
        },
        "166": {
            "config": {
                "id": "existingDebtServiceView"
            },
            "tag": "h4",
            "parent": 165,
            // "html": "DSCR Calculations"
            "html": "Existing Debt Service"
        },
        "167": {
            "config": {
                "class": "data-wrap data-border no-striped"
            },
            "tag": "div",
            "parent": 165
        },
        "168": {
            "config": {
                "class": "row data-head borderbottom m-0 existingDebtServiceHeader"
            },
            "tag": "div",
            "parent": 167
        },

        "175": {
            "config": {
                "class": "data-body existingDebtServiceRow"
            },
            "tag": "div",
            "parent": 167
        },
        "191": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 62
        },
        "192": {
            "config": {
                "class": "input-group"
            },
            "tag": "div",
            "parent": 191
        },
        "193": {
            "config": {
                "for": "debtService",
                "class": "w-50"
            },
            "tag": "label",
            "parent": 192,
            "html": "Existing Debt Service($)"
        },
        "194": {
            "config": {
                "class": "input-group-prepend"
            },
            "tag": "div",
            "parent": 192
        },
        "196": {
            "config": {
                "id": "debtService",
                "type": "text",
                "class": "custom-input input-sm input-dark w-25 ml-2",
                "value": "250059",
                "disabled": true
            },
            "tag": "input",
            "parent": 192,
            "html": ""
        },

        "211": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 62
        },
        "212": {
            "config": {
                "class": "input-group"
            },
            "tag": "div",
            "parent": 211
        },
        "213": {
            "config": {
                "for": "debtAmount",
                "class": "w-50"
            },
            "tag": "label",
            "parent": 212,
            "html": "Incremental Proposed Debt($)"
        },
        "214": {
            "config": {
                "class": "input-group-prepend"
            },
            "tag": "div",
            "parent": 212
        },
        "216": {
            "config": {
                "id": "debtAmount",
                "type": "text",
                "class": "custom-input input-sm input-dark w-25",
                "value": "",
            },
            "tag": "input",
            "parent": 212,
            "events": [
                {
                    "id": "debtAmount",
                    "name": "keypress",
                    "callback": "preventInValidNumbers"
                },
                {
                    "id": "debtAmount",
                    "name": "keyup",
                    "callback": "updateDSCR"
                }
            ]
        },
        "217": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 44
        },
        "218": {
            "config": {
                "class": "card p-0 mt-4",
                "id": "TLPCalculations",
            },
            "tag": "div",
            "parent": 152
        },
        "219": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 218
        },
        "220": {
            "config": {},
            "tag": "h4",
            "parent": 219,
            "html": "Term Loan Principal Calculations"
        },
        "221": {
            "config": {
                "class": "data-wrap data-border no-striped"
            },
            "tag": "div",
            "parent": 219
        },
        "222": {
            "config": {
                "class": "row data-head borderbottom m-0 TLPCalculationsHeader"
            },
            "tag": "div",
            "parent": 221
        },
        "223": {
            "config": {
                "class": "data-body TLPCalculationsRow"
            },
            "tag": "div",
            "parent": 221
        },
        "230": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 127
        },
        "231": {
            "config": {},
            "tag": "h4",
            "parent": 230,
            "html": "Debt Service"
        },
        "232": {
            "config": {
                "class": "data-wrap data-border no-striped"
            },
            "tag": "div",
            "parent": 230
        },
        "233": {
            "config": {
                "class": "row data-head borderbottom m-0 debtServiceInOprHeader"
            },
            "tag": "div",
            "parent": 232
        },
        "234": {
            "config": {
                "class": "data-body debtServiceInOprRow"
            },
            "tag": "div",
            "parent": 232
        },
        "235": {
            "config": {
                "class": "data-wrap data-border no-striped mt-3"
            },
            "tag": "div",
            "parent": 230
        },
        "236": {
            "config": {},
            "tag": "h4",
            "parent": 235,
            "html": "DSCR Calculations"
        },
        "237": {
            "config": {
                "class": "row data-head borderbottom m-0 dscrAccountLevelHeader"
            },
            "tag": "div",
            "parent": 235
        },
        "238": {
            "config": {
                "class": "data-body dscrAccountLevelRow"
            },
            "tag": "div",
            "parent": 235
        }
    };
    return {
        main
    };
})();
